import React from 'react'
import { Link } from 'react-router-dom';


const CalltoAction = () => {
    
  return (
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 p-20">

    <div className="mt-8 text-center shadow-lg rounded-3xl text-white ">
              <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl p-8">
                <h4 className="text-2xl font-bold  mb-4">
                  Prêt à optimiser votre processus de recrutement ?
                </h4>
                <div className='mb-6'>
                    <p className="mb-6 max-w-2xl mx-auto">
                    Jobrise a été conçu pour aider les cabinets de recrutement, les recruteurs indépendants et les équipes de Talent Acquisition à gérer leurs candidats et clients, suivre leurs performances et optimiser chaque étape de leur processus de recrutement.                    </p>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <Link to = "/contact">
                        <button  className="text-white bg-gradient-to-r from-blue-600 to-purple-600 px-8 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all hover:scale-105">
                                Essai Gratuit
                        </button>
                    </Link>
                  
                </div>
              </div>
            </div>
    </div>
  )
}

export default CalltoAction